export default __webpack_public_path__ + "static/media/Modele-de-Registre-des-activites-de-Videosurveillance.20dbe602.xls";